"use client";

import { ReactNode } from "react";
import { ThemeProvider } from "@/components/creations/theme-provider";
import { Toaster } from "@/components/ui/sonner";
import { useTheme } from "next-themes";
import NextTopLoader from "nextjs-toploader";
import { darkPrimaryColor, lightPrimaryColor } from "@/lib/constants";

function ToasterWithInverseTheme() {
  const { resolvedTheme } = useTheme();

  return (
    <Toaster
      theme={resolvedTheme === "dark" ? "light" : "dark"}
      position="bottom-center"
    />
  );
}

export default function Providers({
  children,
  className,
}: {
  children: ReactNode;
  className?: string;
}) {
  const { resolvedTheme } = useTheme();
  const resolvedLoaderColor =
    resolvedTheme === "dark" ? darkPrimaryColor : lightPrimaryColor;
  return (
    <div className={className}>
      <ThemeProvider
        attribute="class"
        defaultTheme="system"
        enableSystem
        disableTransitionOnChange
      >
        <NextTopLoader color={resolvedLoaderColor} showSpinner={false} />
        {children}
        <ToasterWithInverseTheme />
      </ThemeProvider>
    </div>
  );
}
